import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { ArticleType } from '../../article-type.model';
import { Subscription } from 'rxjs';
import { ArticleTypeService } from '../../article-type.service';

@Component({
  selector: 'app-article-type-masterdata',
  templateUrl: './article-type-masterdata.component.html',
  styleUrls: ['./article-type-masterdata.component.scss']
})
export class ArticleTypeMasterdataComponent implements OnInit, OnDestroy {

   _articleType: ArticleType;

  articleTypes = new Array<ArticleType>();
  subscription: Subscription;

  @Input() set articleType(articleType: ArticleType) {
    this._articleType = articleType;
    this.updateFormValues();
  }

  get articleType() {
    return this._articleType;
  }

  profileForm = new FormGroup({
    archived: new FormControl(false, [Validators.required]),
    identifierPattern: new FormControl(''),
    parentArticleTypeId: new FormControl('')
  });


  constructor(
    private articleTypeService: ArticleTypeService
  ) {

  }

  ngOnInit(): void {

    this.subscription = this.articleTypeService.changed$.subscribe(() => {
      this.loadAvailableArticleTypes();
    });

    this.loadAvailableArticleTypes();

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private loadAvailableArticleTypes(): void {
    this.articleTypes = this.articleTypeService.articleTypes;
  }

  private updateFormValues() {

    // this.profileForm.controls.archived.setValue(this.articleType.archived);
    // this.profileForm.controls.identifierPattern.setValue(this.articleType.identifierPattern);

    this.profileForm.patchValue({
      archived: this.articleType.archived,
      identifierPattern: this.articleType.identifierPattern,
      parentArticleTypeId: this.articleType.parentArticleTypeId
    });

    this.profileForm.valueChanges.subscribe(value => {
      this.articleType.archived = this.profileForm.controls.archived.value;
      this.articleType.identifierPattern = value.identifierPattern;
      this.articleType.parentArticleTypeId = value.parentArticleTypeId
      console.log('articleType is', this.articleType);
    });

    // trigger form validation
    this.profileForm.markAllAsTouched();
  }

}
